var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.92074 10.2272H1.1367C0.509043 10.2272 0 10.7362 0 11.3639V23.8639C0 24.491 0.509043 25 1.1367 25H3.92074C4.5484 25 5.05692 24.491 5.05692 23.8639V11.3639C5.05692 10.7362 4.5484 10.2272 3.92074 10.2272Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5686 13.6356H7.78459C7.1564 13.6356 6.64789 14.1447 6.64789 14.7723V23.8627C6.64789 24.4909 7.1564 24.9994 7.78459 24.9994H10.5686C11.1963 24.9994 11.7048 24.4904 11.7048 23.8627V14.7723C11.7048 14.1447 11.1963 13.6356 10.5686 13.6356Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2154 13.6356H14.4314C13.8037 13.6356 13.2952 14.1447 13.2952 14.7723V23.8627C13.2952 24.4909 13.8037 24.9994 14.4314 24.9994H17.2154C17.8436 24.9994 18.3521 24.4904 18.3521 23.8627V14.7723C18.3521 14.1447 17.8436 13.6356 17.2154 13.6356Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8633 10.2272H21.0793C20.4516 10.2272 19.9431 10.7362 19.9431 11.3639V23.8639C19.9431 24.4915 20.4516 25 21.0793 25H23.8633C24.491 25 25 24.4905 25 23.8639V11.3639C25 10.7362 24.491 10.2272 23.8633 10.2272Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8314 6.8457V8.89145C13.4505 8.85049 14.1032 8.56007 14.1032 7.87868C14.1032 7.17549 13.3877 6.96964 12.8314 6.8457Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0521 4.39732C11.0521 4.91434 11.4367 5.21328 12.2117 5.3686V3.51807C11.5074 3.53881 11.0521 3.95264 11.0521 4.39732Z",
    fill: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C9.05372 0 6.25 2.80426 6.25 6.25C6.25 9.69468 9.05372 12.4989 12.5 12.4989C15.9463 12.4989 18.75 9.69468 18.75 6.25C18.75 2.80426 15.9463 0 12.5 0ZM12.8314 9.94628V10.5862C12.8314 10.7622 12.6963 10.9378 12.5197 10.9378C12.3452 10.9378 12.2117 10.7622 12.2117 10.5862V9.94628C10.4654 9.90372 9.59681 8.86011 9.59681 8.04362C9.59681 7.63138 9.84628 7.39309 10.2367 7.39309C11.3941 7.39309 10.4941 8.81915 12.2117 8.89096V6.73138C10.6798 6.45319 9.75213 5.78138 9.75213 4.63457C9.75213 3.22979 10.9202 2.50532 12.2117 2.46489V1.91383C12.2117 1.73777 12.3452 1.56223 12.5197 1.56223C12.6963 1.56223 12.8314 1.73777 12.8314 1.91383V2.46489C13.6367 2.48617 15.2904 2.99149 15.2904 4.00479C15.2904 4.40745 14.9894 4.64468 14.6378 4.64468C13.9654 4.64468 13.975 3.53989 12.8314 3.51862V5.48191C14.1952 5.77181 15.4032 6.17447 15.4032 7.76596C15.4032 9.15 14.3702 9.85213 12.8314 9.94628Z",
    fill: "#B1B1B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.e047d437eb392f0a30c3d019450a93df.svg";
export { ForwardRef as ReactComponent };